import { Button } from '../../index'
import { useI18n } from '@ggs/i18n'
import { useDeleteProjectFlow } from '../../../local'
import './DeleteProjectAction.scss'

/**
 * @typedef {Object} DeleteProjectActionProps
 * @property {string} projectId Drupal project node nid
 */

/**
 * Delete project action button.
 * @param {DeleteProjectActionProps} props
 * @return {JSX.Element}
 */
export const DeleteProjectAction = ({ projectId }) => {
  const { t } = useI18n()
  const { ConfirmDialogComponent, confirmProjectDeletion } = useDeleteProjectFlow({ projectId })

  return (
    <>
      <Button
        label={t('Delete Project')}
        onClick={confirmProjectDeletion}
        classes={{
          root: 'btn--delete'
        }}
      />
      {ConfirmDialogComponent}
    </>
  )
}
